export default __webpack_public_path__ + "static/media/HPSimplified_W_Rg.bbff45c6.woff2";